import logo from '../assets/logo-empresa.png';

const Footer = () => {
  return (
    <footer className="footer py-4 mt-auto">
      <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
        <div className="d-flex align-items-center gap-2">
          <img src={logo} alt="Logo Frog" className="brand-logo-sm" />
          <div className="d-flex flex-column lh-1">
            <span className="text-white fw-semibold">Frog · Inovação</span>
            <small className="text-white-50">Inovação e operações digitais</small>
          </div>
        </div>
        <div className="text-white-50 text-md-end">
          <div>Prefeitura de Uberlândia · Parcerias de Inovação</div>
          <small>© {new Date().getFullYear()} Frog · Todos os direitos reservados</small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
